module.exports = __webpack_public_path__ + "img/clock.c10402a0.svg";